import { useSearchParams } from "react-router-dom";
import { DownloadsPage } from "@/features/exports/DownloadsPage";
import { useAppShell } from "@/shell/app-shell-context";
import { ApiState } from "@/shared/components/ApiState";
import { useRequireCompany } from "@/shared/hooks/useRequireCompany";
import { hasRoleAtLeast } from "@/shared/utils/roles";
import { EXPORT_KINDS, type ExportKind } from "@/shared/vocabulary/exports";

/** `?kind=` só vale se for do vocabulário; `?export=` é o id vindo do sino. */
export function DownloadsRoute() {
  const { token, profile } = useAppShell();
  const company = useRequireCompany();
  const [params, setParams] = useSearchParams();

  if (!company) return null;
  // Pedir exportação é de Técnico na API (2026-10-24).
  if (!hasRoleAtLeast(profile, "technician")) {
    return <ApiState kind="error">Os downloads são de Técnico ou acima.</ApiState>;
  }

  const rawKind = params.get("kind");
  const kind = (EXPORT_KINDS as readonly string[]).includes(rawKind ?? "")
    ? (rawKind as ExportKind)
    : null;
  const rawExport = Number(params.get("export"));
  const highlightId = Number.isInteger(rawExport) && rawExport > 0 ? rawExport : null;

  return (
    <DownloadsPage
      token={token}
      companyId={company.id}
      kind={kind}
      highlightId={highlightId}
      onKindChange={next => {
        const query = new URLSearchParams(params);
        if (next) query.set("kind", next);
        else query.delete("kind");
        // Trocar de aba tira o realce: ele apontava pra uma linha do
        // recorte anterior.
        query.delete("export");
        setParams(query, { replace: true });
      }}
    />
  );
}
